<p-dialog
  [(visible)]="display"
  [contentStyle]="{ height: '350px' }"
  header="{{ ThreadTopicEnum[topicId] }} {{ 'label.Comment' | translate }}"
  (onHide)="onCancel()"
  appendTo="body"
  modal="true"
  width="600"
>
  <p-table
    [value]="posts"
    showGridlines
    [lazy]="true"
    (onLazyLoad)="onLoad($event)"
    [paginator]="true"
    [rows]="pageSize"
    [totalRecords]="totalRecords"
  >
    <ng-template pTemplate="body" let-post>
      <tr>
        <td>
          <div class="comment-text">{{ post.text }}</div>
          <button
            *ngIf="
              !post.isLocked && post.createUser.userId === currentUser?.userId
            "
            pButton
            type="button"
            class="delete-comment"
            icon="fa fa-minus-circle"
            (click)="deleteComment(post.threadPostId)"
          ></button>
          <span style="float: right; padding-top: 1px"
            >{{ post.createUser.fullName }} |
            {{ post.createDate | date : dateFormat }}</span
          >
        </td>
      </tr>
    </ng-template>
  </p-table>
  <ng-template #footer>
    <div>
      <span>{{ 'label.AddComment' | translate }} </span>
      <p-button
        type="button"
        class="add-comment"
        icon="fa fa-plus-circle"
        (click)="addComment()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
